import { Component, OnInit } from '@angular/core';
import { PageStateService } from '../../services/pageStateService';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
})
export class NotFoundComponent implements OnInit {
  constructor(private pageStateService: PageStateService) {}

  ngOnInit(): void {
    this.pageStateService.hideSubscribePanel = true;
  }
}
